import React from "react";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddTransactionForm } from "../../components/transaction";

export const AddTransaction = () => {
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="Cash Out" />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddTransactionForm />
      </Box>
    </PageLayout>
  );
};
